// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"20770":"e0f1a771381822b7","21148":"bba6df26811af87c","64294":"5d40a8fd6838e458"}[chunkId] + ".css";
};